/* eslint-disable react/prefer-stateless-function */
import React from 'react';
import oauth from '../../constants/OAuth2';

class ErrorPage extends React.Component {
  render() {
    const { errorMessage } = this.props;

    return (
      <div
        className="row"
        style={{
          width: '100vw',
          height: '100vh',
          backgroundColor: '#f4f3ef',
        }}
      >
        <div className="col-lg-3 col-md-4 col-sm-6 col-xs-10 login-card">
          <div className="card" style={{ padding: '15px' }}>
            <div className="header">
              <h4
                className="title"
                style={{ textAlign: 'center', color: 'darkred' }}
              >
                <i
                  className="fa fa-close"
                  style={{
                    width: '25px',
                    height: '25px',
                    borderRadius: '100%',
                    border: '1px solid darkred',
                  }}
                />
                {' '}
                                HATA
              </h4>
            </div>
            <div className="content">
              <p style={{ fontSize: '15px', textAlign: 'center' }}>
                { errorMessage || 'Oturumunuz sonlandı. Lütfen tekrar giriş yapınız.' }
              </p>
              <a
                href={`${oauth.dakikaUrl}/payroll/logout.xhtml`}
                style={{ marginTop: '25px' }}
                className="btn btn-info btn-fill btn-block btn-wd"
              >
                    Tekrar giriş yapın
              </a>
            </div>
          </div>
          <small className="text-center" style={{ display: 'block' }}>
                        ©
            {new Date().getFullYear()}
            {' '}
                        All Rights Reserved. Privacy and Terms
          </small>
        </div>
      </div>
    );
  }
}

export default ErrorPage;



// WEBPACK FOOTER //
// ./src/pages/error/index.js